import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { TabList, Tab, TabText, Badge, useThemedValueSwitch } from '@tq/ui-components';

import { GetCaseDetailsResponse } from 'types';

export interface DesktopTabListProps {
  tabLabels: string[];
  caseDetails: GetCaseDetailsResponse | undefined;
  isRpc: boolean;
}
export const DesktopTabList: React.FC<DesktopTabListProps> = ({
  tabLabels,
  caseDetails,
  isRpc,
}) => {
  const { tvs, isTQ } = useThemedValueSwitch();
  const badgeCount = (count = 0): string | number => (count && count > 99 ? '99+' : count);
  const badge = (children: string | number) => {
    if (isTQ)
      return (
        <Badge borderRadius='50%' px='.55rem'>
          {children}
        </Badge>
      );
    return <Badge>{children}</Badge>;
  };
  return (
    <TabList
      color={COLOURS.blue[600]}
      sx={{
        '.tqc-badge': {
          ml: 3,
        },
        '.tqc-tabs__tab:not(:last-of-type)': {
          mr: tvs({ tq: '.375rem' }),
        },
        '.tqc-tabs__tab[aria-selected=true]': {
          borderBottomColor: tvs({ tq: 'transparent' }),
        },
      }}
    >
      <Tab color={COLOURS.blue[600]}>
        <TabText fontSize={20}>{tabLabels[0]}</TabText>
      </Tab>
      {isRpc ? (
        <>
          <Tab
            aria-label={`${badgeCount(caseDetails?.application?.documents?.length)} ${
              tabLabels[1]
            }`}
          >
            <TabText fontSize={20}>{tabLabels[1]}</TabText>
            {!!caseDetails?.application?.documents?.length &&
              badge(badgeCount(caseDetails?.application?.documents?.length))}
          </Tab>
        </>
      ) : (
        <>
          {tabLabels.map((item, index) => {
            if (item === 'Map' || item === 'Related cases') {
              return (
                <Tab key={index}>
                  <TabText fontSize={20}>{item}</TabText>
                </Tab>
              );
            }
            if (item === 'Documents' && caseDetails?.application?.documents) {
              return (
                <Tab
                  key={index}
                  aria-label={`${badgeCount(
                    caseDetails?.application?.documents?.length
                  )} ${item}`}
                >
                  <TabText fontSize={20}>{item}</TabText>
                  {!!caseDetails?.application?.documents?.length &&
                    badge(badgeCount(caseDetails?.application?.documents?.length))}
                </Tab>
              );
            }
            if (item === 'Plans') {
              return (
                <Tab
                  key={index}
                  aria-label={`${badgeCount(caseDetails?.application?.plans?.length)} ${
                    tabLabels[4]
                  }`}
                >
                  <TabText fontSize={20}>{item}</TabText>
                  {!!caseDetails?.application?.plans?.length &&
                    badge(badgeCount(caseDetails?.application?.plans?.length))}
                </Tab>
              );
            }
            if (item === 'Comments') {
              return (
                <Tab
                  key={index}
                  alignRight={true}
                  aria-label={`${badgeCount(
                    caseDetails?.application?.comments?.length
                  )} ${item}`}
                >
                  <TabText fontSize={20}>{item}</TabText>
                  {!!caseDetails?.application?.comments?.length &&
                    badge(badgeCount(caseDetails?.application?.comments?.length))}
                </Tab>
              );
            }
          })}
        </>
      )}
    </TabList>
  );
};
